import snakeCase from 'lodash/snakeCase.js'

import {PRIVACY_MASK} from '../analytics/index.js'

/**
 * A text input field
 *
 * @param {Object} props
 * @param {Array} [props.options]
 * @param {React.ReactNode} [props.children]
 * @param {String} [props.className]
 * @param {String|Boolean} [props.errorMessage]
 * @param {String} [props.id]
 * @param {String} [props.label]
 * @param {String} [props.labelClassName]
 * @param {Boolean} [props.required]
 * @param {Boolean} [props.fsExclude]
 * @param {Function} props.onChange
 * @returns {React.ReactNode}
 */
export default function Select({
  options,
  children,
  className,
  errorMessage,
  id,
  label,
  labelClassName,
  required,
  fsExclude,
  onChange,
  ...props
}) {
  id = id || (label ? snakeCase(label) : undefined)

  return (
    <>
      {label && id && (
        <label className={labelClassName} htmlFor={id}>
          <span>{label}</span>
          {required ? <span className="required">*</span> : null}
        </label>
      )}
      <select
        className={`select ${className || ''} ${
          fsExclude ? PRIVACY_MASK : ''
        } `}
        id={id}
        onChange={(event) => onChange(event.target.value, event)}
        {...props}
      >
        {children}
        {options &&
          options.map(({value, display, disabled}, index) => (
            <option
              key={disabled ? `disabled_${index}` : value}
              value={
                value !== undefined ? value : `value_is_undefined_${index}`
              }
              disabled={disabled}
            >
              {display}
            </option>
          ))}
      </select>
      {errorMessage && (
        <small className="error error-message">{errorMessage}</small>
      )}
    </>
  )
}
